import { Sidebar } from "primereact/sidebar";

const currencyIntl = Intl.NumberFormat('pt-br', { style: 'currency', currency: 'BRL' });

export default function({ order, onHide }) {

    return (
        <Sidebar visible={order} position="right" className="md:w-30rem" onHide={onHide}>
            <div className="h-full flex flex-column">
                <h2>Pedido</h2>
                {order && (
                    <>
                        <div className="w-full flex-grow-1 mt-4 max-w-full flex-shrink-1 overflow-y-hidden overflow-y-scroll">
                            {order.items.map(i => <Item item={i}/>)}
                        </div>
                    </>
                )}
            </div>
        </Sidebar>
    );
}

function Item({ item }) {
    return (
        <div className="py-4 border-solid border-none border-bottom-1 border-300">
            <div className="font-bold mb-1">
                {item.product.description}
            </div>
            <div className="mb-1">
                Cod: {item.product.code}
            </div>
            <div className="mb-1">
                Qtd: {item.quantity} {item.unit.description}
            </div>
        </div>
    )
}